import { render, staticRenderFns } from "./NekretnineView.vue?vue&type=template&id=2d129dae&scoped=true&"
import script from "./NekretnineView.vue?vue&type=script&lang=js&"
export * from "./NekretnineView.vue?vue&type=script&lang=js&"
import style0 from "./NekretnineView.vue?vue&type=style&index=0&id=2d129dae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d129dae",
  null
  
)

export default component.exports